import {
  getCourierLicenseLevel,
  getCourierLicenseNameKey,
} from '../../../domain';

/** Russian labels from v1 i18n (`game.license.*`). */
const COURIER_LICENSE_TIER_LABELS: Record<string, string> = {
  // 'game.license.tier0': 'Ученик',
  'game.license.tier1': 'Тучка на побегушках',
  'game.license.tier2': 'Ветреное облако',
  'game.license.tier3': 'Туманный специалист',
  'game.license.tier4': 'Блуждающий огонёк',
  'game.license.tier5': 'Улётный красавчик',
  'game.license.tier6': 'Звёздный курьер',
  'game.license.tier7': 'Властелин посылок',
  'game.license.tier8': 'Гроза заказов',
  'game.license.tier9': 'Мастер полётов',
  'game.license.tier10': 'Легенда доставки',
};

export function getCourierLicenseTierLabel(nameKey: string): string {
  return COURIER_LICENSE_TIER_LABELS[nameKey] ?? nameKey;
}

/** Display name for the player's current courier license tier. */
export function getCurrentCourierLicenseLabel(
  successfulDeliveries: number,
  averageRating: number,
): string {
  const level = getCourierLicenseLevel(successfulDeliveries, averageRating);
  return getCourierLicenseTierLabel(getCourierLicenseNameKey(level));
}

function formatRatingDisplay(value: number): string {
  return value.toFixed(1).replace('.', ',');
}

export function formatLicenseRequirement(
  minAverageRating: number,
  minSuccessfulDeliveries: number,
): string {
  return `${formatRatingDisplay(minAverageRating)}+ и ${minSuccessfulDeliveries} успешных доставок`;
}
